import * as _ from "lodash";
import * as $ from "jquery";
import * as moment from "moment-timezone";
import {UserGroupCollection} from "../../../collections/UserGroups";
import {UserCollection} from "../../../collections/Users";
import {BaseDetailAccountView, BaseDetailAccountViewOptions} from "../_BaseAccountViews";
import {StatusNotificationCollection} from "../../../collections/StatusNotifications";
import {BaseList, TableProperties} from "../../_BaseList";
import * as Backbone from "backbone";
import {DashboardCollection} from "../../../collections/Dashboards";
import {PermissionCollection} from "../../../collections/Permissions";
import {ModuleCollection} from "../../../collections/Modules";
import {BaseCollection} from "../../../collections/_BaseCollection";
import {DashboardWidgetCollection} from "../../../collections/DashboardWidgets";


export interface InstallDetailViewOptions extends BaseDetailAccountViewOptions {
    currentInstall: Backbone.Model;
    groupPermissionCollections: { [groupId: number]: PermissionCollection };
}

abstract class BaseInstallDetailView extends BaseDetailAccountView {
    options: InstallDetailViewOptions;

    constructor(options: InstallDetailViewOptions) {
        super(<any> _.extend({}, options, {
            className: '',
            events: {}
        }));
    }
}

export class InstallTeamView extends BaseInstallDetailView {

    render() {
        var url = '/#/account/' + this.options.currentOrganizationId + '/installs/' +
            this.options.currentInstall.get('id') + '/teams';
        var footer = this.options.isOverview ? {text: 'View All', url: url} : null;

        this.$el.html(this.template({
            panelTitle: {text: 'Teams with access to this Installation', url: this.options.isOverview ? url : null},
            panelClass: 'teams',
            panelWidth: '',
            addButton: null,
            search: !this.options.isOverview,
            collectionLoaded: this.collectionLoaded,
            footer: footer
        }));
        return this;
    }

    show() {
        var deferreds = this.options.userGroupCollection.map((g) => {
            var id = g.get('id');
            if (!this.options.groupPermissionCollections[id]) {
                this.options.groupPermissionCollections[id] = new PermissionCollection([], {userGroupId: id});
            }
            return this.options.groupPermissionCollections[id].getCollectionFetchPromise();
        });

        $.when.apply($, deferreds).done(() => {
            this.collectionLoaded = true;
            this.render();
            this.showTable();
            (<any> this.$('input[type="checkbox"]')).bootstrapToggle();
        });
    }

    showTable() {
        var teamTable = new BaseList(this.options);
        var teamTableProperties: TableProperties = {
            tableEmptyText: 'There are no Teams with access',
            rowUrl: '#/account/' + this.options.currentOrganizationId + '/teams/',
            columnProperties: {
                'Team Name': {
                    attribute: 'name',
                    columnSizes: {
                        'sm': '5',
                        'md': '5',
                        'xs': '12'
                    }
                },
                'Permissions': {
                    customColumn: {
                        templateFunction: _.template(
                            '<% var perms = []; %>' +
                            '<% if(groupPermissionCollections[mod.get("id")].canViewInstall(installId)) perms.push("View")%>' +
                            '<% if(groupPermissionCollections[mod.get("id")].canModifyInstall(installId)) perms.push("Modify") %>' +
                            '<% if(groupPermissionCollections[mod.get("id")].canDeleteInstall(installId)) perms.push("Delete") %>' +
                            '<% if(groupPermissionCollections[mod.get("id")].canViewSystemStatus(installId)) perms.push("View System Status")%>' +
                            ' <div class="col-md-6 col-sm-6 col-xs-10">' +
                            '<% if(perms.length) { %>' +
                            '<%- perms.join(", ") %>' +
                            '<% } else { %>' +
                            '<%- "None" %>' +
                            '<% }  %>' +
                            ' </div>'),
                        variables: {
                            groupPermissionCollections: this.options.groupPermissionCollections,
                            installId: Number(this.options.currentInstall.get('id')),
                        }
                    },
                    columnSizes: {
                        'sm': '6',
                        'md': '6',
                        'xs': '10'
                    }
                }
            }
        };

        if (this.options.isOverview) {
            teamTableProperties['limitedRows'] = {
                count: 3,
                sortBy: 'is_admin',
                reverseSort: true,
                collectionProperties: {
                    organizationId: this.options.currentOrganizationId
                }
            };
        }

        var teams = this.options.userGroupCollection.filter((team) => {
            return this.options.currentInstall.get('organization_id') === team.get('organization_id')
                && this.options.groupPermissionCollections[team.get('id')].canViewInstall(this.options.currentInstall.get('id'));
        });
        var userGroupCollection = new UserGroupCollection(teams, {organizationId: this.options.currentOrganizationId});
        userGroupCollection.sort();
        this.$('.teams .panel-body > .row').empty().append(
            teamTable.renderCollectionList(userGroupCollection, teamTableProperties).$el
        );

    }
}

export class InstallUserView extends BaseInstallDetailView {

    render() {
        var url = '/#/account/' + this.options.currentOrganizationId + '/installs/' +
            this.options.currentInstall.get('id') + '/users';
        var footer = this.options.isOverview ? {text: 'View All', url: url} : null;

        this.$el.html(this.template({
            panelTitle: {text: 'Users with access to this Installation', url: this.options.isOverview ? url : null},
            panelClass: 'users',
            panelWidth: '',
            addButton: null,
            search: !this.options.isOverview,
            collectionLoaded: this.collectionLoaded,
            footer: footer
        }));
        return this;
    }

    show() {
        var deferreds = this.options.userGroupCollection.map((g) => {
            var id = g.get('id');
            if (!this.options.groupPermissionCollections[id]) {
                this.options.groupPermissionCollections[id] = new PermissionCollection([], {userGroupId: id});
            }
            return this.options.groupPermissionCollections[id].getCollectionFetchPromise();
        });

        $.when.apply($, deferreds).done(() => {
            this.collectionLoaded = true;
            this.render();
            this.showTable();
            (<any> this.$('input[type="checkbox"]')).bootstrapToggle();
        });
    }

    showTable() {
        var usersTable = new BaseList(this.options);
        var usersTableProperties: TableProperties = {
            rowUrl: '#/account/' + this.options.currentOrganizationId + '/users/',
            tableEmptyText: 'There are no Users with access',
            columnProperties: {
                'Name': {
                    attribute: 'name',
                    columnSizes: {
                        'sm': '3',
                        'md': '3',
                        'xs': '12'
                    }
                },
                'Email': {
                    attribute: 'email',
                    columnSizes: {
                        'sm': '3',
                        'md': '3',
                        'xs': '12'
                    }
                },
                'Phone Number': {
                    attribute: 'phone_number',
                    columnSizes: {
                        'sm': '2',
                        'md': '2',
                        'xs': '12'
                    }
                },
                'Permissions': {
                    attribute: 'usergroups',
                    customColumn: {
                        templateFunction: _.template('<% var perms = []; %> ' +
                            ' <% _.each(mod.get("usergroups"), function(g, id) { %> ' +
                            ' <% var uGroup  = userGroupCollection.findWhere({id: Number(id)}) %>' +
                            ' <% if(groupPermissionCollections[uGroup.get("id")].canViewInstall(installId)) perms.push("View")%>' +
                            ' <% if(groupPermissionCollections[uGroup.get("id")].canModifyInstall(installId)) perms.push("Modify") %>' +
                            ' <% if(groupPermissionCollections[uGroup.get("id")].canDeleteInstall(installId)) perms.push("Delete") %>' +
                            ' <% }); %>' +
                            ' <div class="col-md-3 col-sm-2 col-xs-10 account-modify-team-member-since">' +
                            ' <%- _.uniq(perms).join(", ") %>' +
                            ' </div>'
                        ),
                        variables: {
                            userGroupCollection: this.options.userGroupCollection,
                            groupPermissionCollections: this.options.groupPermissionCollections,
                            installId: Number(this.options.currentInstall.get('id')),
                        }
                    },
                    columnSizes: {
                        'sm': '2',
                        'md': '2',
                        'xs': '10'
                    }
                }
            }
        };

        if (this.options.isOverview) {
            usersTableProperties['limitedRows'] = {
                count: 3,
                sortBy: 'name',
                reverseSort: false,
                collectionProperties: {
                    organizationId: this.options.currentOrganizationId
                }
            };
        }

        var users = this.options.userCollection.filter((user) => {
            var canView = false;
            _.each(user.get('usergroups'), (uGroup, id) => {
                if (this.options.groupPermissionCollections[Number(id)].canViewInstall(Number(this.options.currentInstall.get('id')))) {
                    canView = true;
                    return false;
                }
            });

            return canView;
        });
        var userCollection = new UserCollection(users, {organizationId: this.options.currentOrganizationId});
        this.$('.users .panel-body > .row').empty().append(
            usersTable.renderCollectionList(userCollection, usersTableProperties).$el
        );
    }
}

export class InstallDashboardView extends BaseInstallDetailView {

    private dashboardWidgetCollections: { [dashboardId: number]: DashboardWidgetCollection } = {};

    render() {
        var url = '/#/account/' + this.options.currentOrganizationId + '/installs/' +
            this.options.currentInstall.get('id') + '/dashboards';
        var footer = this.options.isOverview ? {text: 'View All', url: url} : null;

        this.$el.html(this.template({
            panelTitle: {
                text: 'Dashboards with channels from this Installation',
                url: this.options.isOverview ? url : null
            },
            panelClass: 'dashboards',
            panelWidth: '',
            addButton: null,
            search: !this.options.isOverview,
            collectionLoaded: this.collectionLoaded,
            footer: footer
        }));
        return this;
    }

    private getRelevantDashboardIds() {
        var dashboardIds = [];
        this.options.dashboardChannelCollection.each((c) => {
            if (c.get('install_id') === this.options.currentInstall.get('id')
               && c.get('dashboard_organization_id') === this.options.currentOrganizationId) {

                dashboardIds.push(c.get('dashboard_channel_dashboard_id'));
            }
        });
        return _.uniq(dashboardIds);
    }

    show() {
        var deferreds = _.map(this.getRelevantDashboardIds(), (id) => {
            this.dashboardWidgetCollections[id] = new DashboardWidgetCollection([], {dashboardId: id});
            return this.dashboardWidgetCollections[id].getCollectionFetchPromise();
        });

        $.when.apply($, deferreds).done(() => {
            this.collectionLoaded = true;
            this.render();
            this.showTable();
            (<any> this.$('input[type="checkbox"]')).bootstrapToggle();
        });
    }

    showTable() {
        var getDashboardModifiedDate = function (dash, widCols) {
            var dates = [moment(dash.get('modified')).format("L")];
            var widgetDate = 0;
            widCols[dash.get('id')].each((widget) => {
                if (widget.get('modified') > widgetDate) widgetDate = widget.get('modified')
            });

            if (widgetDate !== 0) dates.push(moment.unix(widgetDate).format("L"));

            dates = _.sortBy(dates, (date) => {
                return date;
            }).reverse();

            return _.first(dates);
        };

        var dashboardTable = new BaseList(this.options);
        var dashboardTableProperties: TableProperties = {
            rowUrl: '#/dashboard/',
            tableEmptyText: 'There are no Dashboards with Channels from this Installation',
            columnProperties: {
                'Name': {
                    attribute: 'name',
                    columnSizes: {
                        'sm': '3',
                        'md': '3',
                        'xs': '12'
                    }
                },
                'Number of Channels': {
                    attribute: 'usergroups',
                    centerColumn: true,
                    customColumn: {
                        templateFunction: _.template('<% var channels = dashboardChannelCollection.where({dashboard_channel_dashboard_id: mod.get("id"), install_id: installId})%> ' +
                            ' <div class="col-md-2 col-sm-2 col-xs-10 text-center account-modify-team-member-since">' +
                            ' <%- channels.length %>' +
                            ' </div>'
                        ),
                        variables: {
                            userGroupCollection: this.options.userGroupCollection,
                            groupPermissionCollections: this.options.groupPermissionCollections,
                            installId: Number(this.options.currentInstall.get('id')),
                            dashboardChannelCollection: this.options.dashboardChannelCollection,
                        }
                    },
                    columnSizes: {
                        'sm': '2',
                        'md': '2',
                        'xs': '10'
                    }
                },
                'Created': {
                    centerColumn: true,
                    customColumn: {
                        templateFunction: _.template('<% var inviteDate = mod.get("created") ? mod.get("created") : null %> ' +
                            ' <% if(inviteDate){ %> ' +
                            ' <div class="col-md-3 col-sm-3 col-xs-10 text-center"><%- moment(inviteDate).format("L") %></div>' +
                            ' <% }else{ %>' +
                            ' <div class="col-md-3 col-sm-3 col-xs-10 text-center">' +
                            ' ' +
                            ' </div>' +
                            ' <% } %>'),
                        variables: {
                            moment: moment
                        }
                    },
                    columnSizes: {
                        'sm': '3',
                        'md': '3',
                        'xs': '10'
                    }
                },
                'Modified': {
                    centerColumn: true,
                    customColumn: {
                        templateFunction: _.template('' +
                            '<% var inviteDate = getDashboardModifiedDate(mod, widCols) %> ' +
                            ' <div class="col-md-3 col-sm-3 col-xs-10 text-center"><%- inviteDate ? inviteDate : "" %></div>'
                        ),
                        variables: {
                            moment: moment,
                            widCols: this.dashboardWidgetCollections,
                            getDashboardModifiedDate: getDashboardModifiedDate
                        }
                    },
                    columnSizes: {
                        'sm': '3',
                        'md': '3',
                        'xs': '10'
                    }
                }
            }
        };

        if (this.options.isOverview) {
            dashboardTableProperties['limitedRows'] = {
                count: 3,
                sortBy: 'name',
                reverseSort: false,
                collectionProperties: {
                    organizationId: this.options.currentOrganizationId
                }
            };
        }

        var relevantDashboardIds = this.getRelevantDashboardIds();
        var dashboardCollection = new DashboardCollection(this.options.dashboardCollection.filter((d) => {
            return _.includes(relevantDashboardIds, d.get('id'));
        }));
        this.$('.dashboards .panel-body > .row').empty().append(
            dashboardTable.renderCollectionList(dashboardCollection, dashboardTableProperties).$el
        );
    }
}

export class InstallModuleView extends BaseInstallDetailView {

    private moduleCollection: ModuleCollection = null;

    render() {
        var url = '/#/account/' + this.options.currentOrganizationId + '/installs/' +
            this.options.currentInstall.get('id') + '/modules';
        var footer = this.options.isOverview ? {text: 'View All', url: url} : null;

        this.$el.html(this.template({
            panelTitle: {text: 'Modules in this Installation', url: this.options.isOverview ? url : null},
            panelClass: 'modules',
            panelWidth: '',
            addButton: null,
            search: !this.options.isOverview,
            collectionLoaded: this.collectionLoaded,
            footer: footer
        }));
        return this;
    }

    show() {
        this.moduleCollection = new ModuleCollection([], {installId: this.options.currentInstall.get('id')});
        $.when(this.moduleCollection.getCollectionFetchPromise()).done(() => {
            this.collectionLoaded = true;
            this.render();
            this.showTable();
            (<any> this.$('input[type="checkbox"]')).bootstrapToggle();
        });
    }

    showTable() {
        var modulesTable = new BaseList(this.options);
        var modulesTableProperties: TableProperties;
        modulesTableProperties = {
            rowUrl: '#/status/' + this.options.currentOrganizationId + '/' + this.options.currentInstall.get('id') + '/',
            rowUrlAttribute: 'module_id',
            tableEmptyText: 'There are no Modules in this Installation',
            columnProperties: {
                'Name': {
                    customColumn: {
                        templateFunction: _.template(
                            '<div class="col-md-2 col-sm-2 col-xs-10" data-table-cell=<%- mod.getDisplayName() %> >' +
                            '<%-  mod.getDisplayName() %>' +
                            '</div>'
                        ),
                        variables: {
                            moment: moment
                        }
                    },
                    columnSizes: {
                        'sm': '2',
                        'md': '2',
                        'xs': '10'
                    }
                },
                'Sampling Frequency': {
                    customColumn: {
                        templateFunction: _.template(
                            '<% var pf = mod.getPollingFrequency() %>' +
                            '<% var mins = moment.duration(pf, "seconds").minutes() %>' +
                            '<% var minString =  mins > 1 ? " minutes" : " minute"%>' +
                            '<% if(pf < 60 ) { %>' +
                            '<% mins =  moment.duration(pf, "seconds").seconds() %>' +
                            '<% minString =  mins > 1 ? " seconds" : " second"%>' +
                            '<% } %>' +
                            '<% if(pf >= 3600 ) { %>' +
                            '<% mins =  moment.duration(pf, "seconds").hours() %>' +
                            '<% minString =  mins > 1 ? " hours" : " hour"%>' +
                            '<% } %>' +
                            '<div class="col-md-2 col-sm-2 col-xs-10" data-table-cell=<%- mins ? (mins + minString) : "" %> >' +
                            '<%- mins ? mins + minString : "" %>' +
                            '</div>'
                        ),
                        variables: {
                            moment: moment
                        }
                    },
                    columnSizes: {
                        'sm': '2',
                        'md': '2',
                        'xs': '10'
                    }
                },
                'Sensors': {
                    centerColumn: true,
                    customColumn: {
                        templateFunction: _.template(' <div class="col-md-1 col-sm-1 col-xs-10 text-center">' +
                            ' <% var sensors = 0 %>' +
                            ' <% _.each([1, 2, 3, 4], function(connector) { %>' +
                            ' <%    var con = mod.showConnector(connector); %>' +
                            ' <%    if(con) sensors++; %>' +
                            ' <% }) %>' +
                            ' <%- sensors ? sensors : "" %>' +
                            ' </div>'),
                    },
                    columnSizes: {
                        'sm': '1',
                        'md': '1',
                        'xs': '12'
                    }
                },
                'Gateway': {
                    centerColumn: true,
                    customColumn: {
                        templateFunction: _.template(
                            ' <div class="col-md-2 col-sm-2 col-xs-10 text-center ">' +
                            ' <%- mod.get("module_is_gateway") ? "Yes" : "No" %>' +
                            ' </div>'),
                    },
                    columnSizes: {
                        'sm': '2',
                        'md': '2',
                        'xs': '12'
                    }
                },
                'Created': {
                    centerColumn: true,
                    customColumn: {
                        templateFunction: _.template('<% var inviteDate = mod.get("module_created") ? mod.get("module_created") : null %> ' +
                            ' <% if(inviteDate){ %> ' +
                            ' <div class="col-md-2 col-sm-2 col-xs-10 text-center"><%- moment.unix(inviteDate).format("L") %></div>' +
                            ' <% }else{ %>' +
                            ' <div class="col-md-2 col-sm-2 col-xs-10 text-center">' +
                            ' ' +
                            ' </div>' +
                            ' <% } %>'),
                        variables: {
                            moment: moment
                        }
                    },
                    columnSizes: {
                        'sm': '2',
                        'md': '2',
                        'xs': '10'
                    }
                },
                'Modified': {
                    centerColumn: true,
                    customColumn: {
                        templateFunction: _.template('<% var inviteDate = mod.get("module_modified") ? mod.get("module_modified") : null %> ' +
                            ' <% if(inviteDate){ %> ' +
                            ' <div class="col-md-2 col-sm-2 col-xs-10 text-center"><%- moment.unix(inviteDate).format("L") %></div>' +
                            ' <% }else{ %>' +
                            ' <div class="col-md-2 col-sm-2 col-xs-10 text-center">' +
                            ' ' +
                            ' </div>' +
                            ' <% } %>'),
                        variables: {
                            moment: moment
                        }
                    },
                    columnSizes: {
                        'sm': '2',
                        'md': '2',
                        'xs': '10'
                    }
                }
            }
        };

        if (this.options.isOverview) {
            modulesTableProperties['limitedRows'] = {
                count: 3,
                sortBy: 'module_is_gateway',
                reverseSort: true,
                collectionProperties: {
                    organizationId: this.options.currentOrganizationId
                }
            };
        }

        this.$('.modules .panel-body > .row').empty().append(
            modulesTable.renderCollectionList(this.moduleCollection, modulesTableProperties).$el
        );
    }
}

export class InstallNotificationView extends BaseInstallDetailView {

    private statusNotificationCollections: { [groupId: number]: StatusNotificationCollection } = {};

    render() {
        var url = '/#/account/' + this.options.currentOrganizationId + '/installs/' +
            this.options.currentInstall.get('id') + '/notifications';
        var footer = this.options.isOverview ? {text: 'View All', url: url} : null;

        this.$el.html(this.template({
            panelTitle: {text: 'Installation Notifications', url: this.options.isOverview ? url : null},
            panelClass: 'install-notifications',
            panelWidth: '',
            addButton: null,
            search: !this.options.isOverview,
            collectionLoaded: this.collectionLoaded,
            footer: footer
        }));
        return this;
    }

    show() {
        var deferreds = this.options.userGroupCollection.map((g) => {
            var id = g.get('id');
            this.statusNotificationCollections[id] = new StatusNotificationCollection([], {userGroupId: id});
            return this.statusNotificationCollections[id].getCollectionFetchPromise();
        });

        $.when.apply($, deferreds).done(() => {
            this.collectionLoaded = true;
            this.render();
            this.showTable();
            (<any> this.$('input[type="checkbox"]')).bootstrapToggle();
        })
    }

    showTable() {
        var notificationInstallTable = new BaseList(this.options);
        var notificationInstallTableProperties: TableProperties = {
            tableEmptyText: 'There are no Installation Notifications',
            columnProperties: {
                'Team': {
                    customColumn: {
                        templateFunction: _.template(
                            '<% var uId = mod.get("usergroup_id") %>' +
                            '<% var team = userGroupCollection.findWhere({id: uId}) %>' +
                            '<div class="col-md-4 col-sm-4 col-xs-10" data-table-cell="<%- mod.get("enable_sms_notifications") ? "Enabled" : "Disabled" %>">' +
                            '<%- team.get("name") %>' +
                            '</div>'),
                        variables: {
                            userGroupCollection: this.options.userGroupCollection
                        }
                    },
                    columnSizes: {
                        'sm': '4',
                        'md': '4',
                        'xs': '12'
                    }
                },
                'Interval': {
                    customColumn: {
                        templateFunction: _.template(
                            '<% var di = mod.get("digest_interval") %>' +
                            '<% var interval = "Immediately" %>' +
                            '<% if(di === 3600) { %>' +
                            '<% interval = "At most hourly"%>' +
                            '<% } %>' +
                            '<% if(di === 21600) { %>' +
                            '<% interval = "At most every 6 hours"%>' +
                            '<% } %>' +
                            '<% if(di === 43200) { %>' +
                            '<% interval = "At most every 12 hours"%>' +
                            '<% } %>' +
                            '<% if(di === 86400) { %>' +
                            '<% interval = "At most daily"%>' +
                            '<% } %>' +
                            '<div class="col-md-2 col-sm-2 col-xs-10" data-table-cell=<%- interval %> >' +
                            '<%- interval %>' +
                            '</div>'),
                    },
                    columnSizes: {
                        'sm': '2',
                        'md': '2',
                        'xs': '12'
                    }
                },
                'Enabled Notifications': {
                    customColumn: {
                        templateFunction: _.template(
                            '<div class="col-md-2 col-sm-2 col-xs-10" data-table-cell="<%- mod.get("enable_email_notifications") ? "Enabled" : "Disabled" %>">' +
                            '<% notifs = [] %>' +
                            '<% mod.get("enable_email_notifications") ? notifs.push("Email") : "" %>' +
                            '<% mod.get("enable_sms_notifications") ? notifs.push("Text") : "" %>' +
                            '<%- notifs.join(", ") %>' +
                            '</div>'),
                    },
                    columnSizes: {
                        'sm': '2',
                        'md': '2',
                        'xs': '12'
                    }
                },
                'Weekday Quiet Time': {
                    customColumn: {
                        templateFunction: _.template(
                            '<% var from = mod.get("quiet_time_weekday_start_seconds") %>' +
                            '<% var to = mod.get("quiet_time_weekday_end_seconds") %>' +
                            '<div class="col-md-2 col-sm-2 col-xs-10" data-table-cell=<%- from %> >' +
                            '<%- from ? moment.utc(from * 1000).format("h:mm A") + " to " : "" %>' +
                            '<%- to ? moment.utc(to * 1000).format("h:mm A") : "" %>' +
                            '</div>'),
                        variables: {
                            moment: moment
                        },
                    },
                    columnSizes: {
                        'sm': '2',
                        'md': '2',
                        'xs': '12'
                    }
                },
                'Weekend Quiet Time': {
                    customColumn: {
                        templateFunction: _.template(
                            '<% var from = mod.get("quiet_time_weekend_start_seconds") %>' +
                            '<% var to = mod.get("quiet_time_weekend_end_seconds") %>' +
                            '<div class="col-md-2 col-sm-2 col-xs-10" data-table-cell=<%- moment.utc(from * 1000).format("h:mm A") + moment.utc(to * 1000).format("h:mm A")%> >' +
                            '<%- from ? moment.utc(from * 1000).format("h:mm A") + " to " : "" %>  ' +
                            '<%- to ? moment.utc(to * 1000).format("h:mm A") : "" %>' +
                            '</div>'),
                        variables: {
                            moment: moment
                        },
                    },
                    columnSizes: {
                        'sm': '2',
                        'md': '2',
                        'xs': '12'
                    }
                },
            }
        };

        if (this.options.isOverview) {
            notificationInstallTableProperties['limitedRows'] = {
                count: 3,
                sortBy: 'enable_email_notifications',
                reverseSort: true,
                collectionProperties: {
                    organizationId: this.options.currentOrganizationId
                }
            };
        }

        var notifs = [];
        _.each(this.statusNotificationCollections, (col: StatusNotificationCollection) => {
            var instNot = col.findWhere({install_id: this.options.currentInstall.get('id')});
            if (instNot && (instNot.get("enable_email_notifications") || instNot.get("enable_sms_notifications"))) {
                notifs.push(instNot)
            }
        });
        var dashboardNotifications = new BaseCollection(_.uniq(notifs));
        this.$('.install-notifications .panel-body > .row').empty().append(
            notificationInstallTable.renderCollectionList(dashboardNotifications, notificationInstallTableProperties).$el
        );
    }
}


// WEBPACK FOOTER //
// ./srv/public/js/views/account/installs/InstallDetailViews.ts